<template>
          <section class="sidebar-layout">
             <b-sidebar
                position="static"
                mobile="fullwidth"
                :fullheight="true"
                :expand-on-hover="true"
                :reduce="false"
                type="is-dvoalts"
                open
            >
                <div class="p-1 py-6 pl-2">
                    <b-menu class="is-custom-mobile">
                        <b-menu-list label="General">
                            <b-menu-item label="Website Header/Links" tag="router-link" :to="{ name: 'HeaderUtil'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Reports">
                            <b-menu-item label="Warranty Report" tag="router-link" :to="{ name: 'Reports'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Users">
                                <b-menu-item label="Manage Users" tag="router-link" :to="{ name: 'User' }"></b-menu-item>
                                <b-menu-item label="Manage User Roles" tag="router-link" :to="{ name: 'UserRoles' }"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Admin">
                                <b-menu-item label="Admin Manager" tag="router-link" :to="{ name: 'AdminManager' }"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Products">
                            <b-menu-item label="Product Manager" tag="router-link" :to="{ name: 'ProductList' }"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Parts">
                            <b-menu-item label="Spare Part Manager" tag="router-link" :to="{ name: 'PartList' }"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Companies">
                            <b-menu-item label="Company Approvals" tag="router-link" :to="{ name: 'CompanyApproval' }"></b-menu-item>
                            <b-menu-item label="Company Manager"  tag="router-link" :to="{ name: 'Company'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Items">
                            <b-menu-item label="Item Manager" tag="router-link" :to="{ name: 'Item'}"></b-menu-item>
                            <b-menu-item label="Batch Serial Imports" tag="router-link" :to="{ name: 'BatchImport'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Service Codes">
                            <b-menu-item label="Service Code Manager" tag="router-link" :to="{ name: 'ServiceCode'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Associations">
                            <b-menu-item label="Match Parts to Products" tag="router-link" :to="{ name: 'AddPartsToProduct'}"></b-menu-item>
                            <b-menu-item label="Match Parts to Codes"  tag="router-link" :to="{ name: 'AddServiceParts'}"></b-menu-item>
                        </b-menu-list>
                        <b-menu-list label="Archive">
                            <b-menu-item label="Visit Warranty Archive" tag="router-link" :to="{ name: 'Archive' }"></b-menu-item>
                        </b-menu-list>
                    </b-menu>
                </div>
            </b-sidebar>
        </section>
</template>

<script>
export default {

}
</script>

<style>

</style>